import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { AgencyBeaState } from './AgencyBeaState';
import { BeaSelector } from './BeaSelector';
import { OrganizationsState } from '../organizations/OrganizationsState';

/** Opens agency Bea, or undefined where the api does not offer her the caseload. */
export const useAgencyBea = (): AgencyBeaState['open'] | undefined => {
    const agencyBea = useInstance(AgencyBeaState);
    const selector = useInstance(BeaSelector);
    const orgState = useInstance(OrganizationsState);
    useSubscription(() => orgState);

    return selector.getAgencyOrganization() ? agencyBea.open : undefined;
};
